import React from 'react';
import { useField } from 'formik';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

const MyDateTimePicker = ({ name, label, ...props }) => {
    const [field, meta, helpers] = useField(name);
    const { setValue, setTouched } = helpers;

    // Convierte el valor del field a un objeto moment, si existe.
    const value = field.value ? moment(field.value, 'YYYY-MM-DD HH:mm:ss') : null;

    const handleChange = (date) => {
        // date es un objeto Moment. Verifica que sea válido antes de formatearlo.
        if (date && date.isValid()) {
            setValue(date.format('YYYY-MM-DD HH:mm:ss'));
        } else {
            setValue('');
        }
    };

    const handleBlur = () => {
        setTouched(true);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
                label={label}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                maxDate={moment()} // Restringe la fecha máxima hasta hoy
                renderInput={(params) => (
                    <TextField
                        {...params}
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched && meta.error ? meta.error : ''}
                    />
                )}
                {...props}
            />
        </LocalizationProvider>
    );
};

export default MyDateTimePicker;